<template>
  <div class="basic_con">
    <Frame title="">
      <template slot="headerSlot">
        <div class="flex_wrapper">
          <el-button
            size="small"
            type="primary"
            :disabled="isShow()"
            @click.stop="copyVisible = true"
            v-if="!readOnly"
          >
            复制方案
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click.stop="save('calc')"
            :disabled="isShow()"
            :loading="loading"
            v-if="!readOnly&&permission.factoringQuotaSchemeList_edit"
          >
            测算</el-button
          >
          <el-button
            size="small"
            :loading="loading"
            @click.stop="save('submit')"
            :disabled="isShow()"
            v-if="!readOnly&&permission.factoringQuotaSchemeList_edit"
          >
            保存
          </el-button>
        </div>
      </template>
      <template slot="contentSlot">
        <div class="con_wrapper">
          <avue-form
            ref="form"
            v-model="form"
            :option="option"
            @submit="handleSubmit"
          >
            <!-- <template slot="nameTemplate">
              <div class="flex_wrapper">
                <CommonSelect
                  :disabled="readOnly"
                  searchKey="name"
                  bindLabel="name"
                  bindKey="id"
                  bindValue="id"
                  methods="get"
                  dataMethod="params"
                  dataUrl="bl/blcontractrental/page"
                  @handleChange="(el) => setId(el)"
                />
                 <el-button
                  style="margin-left: 5px"
                  size="small"
                  plain
                  link
                  @click.stop="copy()"
                  >复制方案
                </el-button> 
              </div>
            </template> -->
            <template slot="blCustNamesLabel">
              <span> </span>
            </template>

            <template slot="custName">
              <CommonSelect
                :disabled="isShow()"
                bindLabel="custName"
                searchKey="custName"
                bindKey="id"
                bindValue="custName"
                methods="get"
                dataMethod="params"
                dataUrl="/bl/custbasicinformationbl/page"
                @handleChange="changeCustName"
                :bindId="form['custId'] ? form['custId'] : ''"
              />

              <!-- <el-select
                :disabled="isShow()"
                filterable
                v-model="form['custName']"
                placeholder="输入关键字搜索客户"
                value-key="id"
                @change="changeCustName"
              >
                <el-option
                  v-for="item in basicList"
                  :key="item.id"
                  :label="item.custName"
                  :value="item"
                >
                </el-option>
              </el-select> -->
            </template>
            <template slot="anticipatedValueDate">
              <div class="form_slot">
                <el-date-picker
                  :disabled="isShow()"
                  v-model="form['anticipatedValueDate']"
                  type="date"
                  format="yyyy-MM-dd"
                  valueFormat="yyyyMMdd"
                  placeholder="请输入"
                  @change="changeAnticipatedValueDate"
                />
              </div>
            </template>

            <template slot="downPayment">
              <div class="flex_wrapper">
                <el-input
                  :disabled="isShow()"
                  v-model="form['downPayment']"
                  placeholder="输入比例"
                  type="number"
                  @change="
                    changeInput('downPayment_money', 'downPayment', 'ratio')
                  "
                >
                  <template slot="append">%</template>
                </el-input>

                <el-input
                  :disabled="isShow()"
                  v-model="form['downPayment_money']"
                  placeholder="输入金额"
                  style="margin-left: 10px"
                  type="number"
                  @change="
                    changeInput('downPayment', 'downPayment_money', 'number')
                  "
                >
                  <template slot="append">元</template>
                </el-input>
              </div>
            </template>
            <template slot="calculateRentMethod">
              <el-radio-group v-model="form['calculateRentMethod']">
                <el-radio-button
                  :label="item.dictKey"
                  v-for="(item, index) in dataSouce['calculate_rent_method']"
                  :key="index"
                  :disabled="isShow()"
                >
                  {{ item.dictValue }}</el-radio-button
                >
              </el-radio-group>
            </template>
            <template slot="interestTaxRate">
              <el-radio-group v-model="form['interestTaxRate']">
                <el-radio-button
                  :label="item.dictKey"
                  v-for="(item, index) in dataSouce['interest_tax_rate']"
                  :key="index"
                  :disabled="isShow()"
                >
                  {{ item.dictValue }}</el-radio-button
                >
              </el-radio-group>
            </template>
            <template slot="purchasePrice">
              <div class="flex_wrapper">
                <el-input
                  :disabled="isShow()"
                  v-model="form['purchasePrice']"
                  placeholder="输入比例"
                  type="number"
                  @change="
                    changeInput('purchasePrice_money', 'purchasePrice', 'ratio')
                  "
                >
                  <template slot="append">%</template>
                </el-input>

                <el-input
                  v-model="form['purchasePrice_money']"
                  placeholder="输入金额"
                  style="margin-left: 10px"
                  :disabled="isShow()"
                  @change="
                    changeInput(
                      'purchasePrice',
                      'purchasePrice_money',
                      'number'
                    )
                  "
                >
                  <template slot="append">元</template>
                </el-input>
              </div>
            </template>
            <template slot="repaymentFrequency">
              <el-radio-group v-model="form['repaymentFrequency']">
                <el-radio-button
                  :label="item.dictKey"
                  :disabled="isShow()"
                  v-for="(item, index) in dataSouce['repayment_frequency']"
                  :key="index"
                >
                  {{ item.dictValue }}</el-radio-button
                >
              </el-radio-group>
            </template>
            <template slot="repaymentFrequencyBl">
              <el-radio-group v-model="form['repaymentFrequency']">
                <el-radio-button
                  :label="item.dictKey"
                  disabled
                  v-for="(item, index) in dataSouce['repayment_frequency']"
                  :key="index"
                >
                  {{ item.dictValue }}</el-radio-button
                >
              </el-radio-group>
            </template>
            <template slot="paymentType">
              <el-radio-group v-model="form['paymentType']">
                <el-radio-button
                  :label="item.dictKey"
                  v-for="(item, index) in dataSouce['payment_type_rzzl']"
                  :key="index"
                  :disabled="isShow()"
                >
                  {{ item.dictValue }}</el-radio-button
                >
              </el-radio-group>
            </template>
            <template slot="interestRateModel">
              <el-radio-group v-model="form['interestRateModel']">
                <el-radio-button
                  :label="item.dictKey"
                  v-for="(item, index) in dataSouce['interest_rate_model']"
                  :key="index"
                  :disabled="isShow()"
                >
                  {{ item.dictValue }}</el-radio-button
                >
              </el-radio-group>
            </template>
            <template slot="benchmarkInterestRateName">
              <div class="flex_wrapper">
                <CommonSelect
                  :disabled="isShow()"
                  bindLabel="name"
                  bindKey="id"
                  bindValue="name"
                  methods="get"
                  dataMethod="params"
                  dataUrl="blade-/zd/interestrate/lpr/bl"
                  @handleChange="setLpr"
                />

                <el-input
                  v-model="form['benchmarkInterestRateValue']"
                  placeholder="回显"
                  style="margin-left: 10px"
                  disabled
                >
                  <template slot="append">%</template>
                </el-input>
              </div>
            </template>
            <template slot="floatingMode">
              <el-radio-group v-model="form['floatingMode']">
                <el-radio-button
                  :label="item.dictKey"
                  v-for="(item, index) in dataSouce['floating_mode']"
                  :key="index"
                  :disabled="isShow()"
                >
                  {{ item.dictValue }}</el-radio-button
                >
              </el-radio-group>
            </template>
            <template slot="interestAdjustmentMode">
              <el-radio-group v-model="form['interestAdjustmentMode']">
                <el-radio-button
                  :label="item.dictKey"
                  v-for="(item, index) in dataSouce['interest_adjustment_mode']"
                  :key="index"
                  :disabled="isShow()"
                >
                  {{ item.dictValue }}</el-radio-button
                >
              </el-radio-group>
            </template>
          </avue-form>
        </div>
        <TableCustom
          ref="tableCustom"
          :tableData="tableData"
          :quotationPrice="form['quotationPrice']"
          :readOnly="isShow()"
        />

        <BondTableCustom
          ref="bondTableCustom"
          :tableData="bondTableData"
          :quotationPrice="form['quotationPrice']"
          :readOnly="isShow()"
        />
      </template>
    </Frame>

    <el-dialog
      :close-on-click-modal="false"
      title="复制方案"
      :visible.sync="copyVisible"
      :modal-append-to-body="false"
      width="40%"
    >
      <div class="flex_wrapper">
        <el-form ref="copyNameForm" label-width="80px" style="width: 100%">
          <el-form-item label="复制方案:">
            <CommonSelect
              selectStyle="true"
              :disabled="readOnly"
              searchKey="name"
              bindLabel="name"
              bindKey="id"
              bindValue="id"
              methods="get"
              dataMethod="params"
              dataUrl="bl/blcontractrental/page"
              @handleChange="(el) => setId(el)"
            />
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Frame from "./frame.vue";
import * as api from "@/api/factoring/factoringScheme";
import {
  dictionaries,
  queryInventedId,
} from "@/api/factoring/factoringCustomer";
import { getQuotaDetail } from "@/api/factoring/factoringScheme";
import { mapGetters } from "vuex";
import { basicConfig } from "../config";
import { basicInformations } from "@/api/zd/visit";
import TableCustom from "./tableCustom";
import BondTableCustom from "./bondTableCustom";
import { getDept } from "@/api/system/dept";
import CommonSelect from "@/components/commonSelect/commonSelect";
import moment from "moment";
import util from "@/mixins/util";
import { floatMul,floatDiv } from "@/util/util";
export default {
  name: "basicsForm",
  mixins: [util],
  components: {
    Frame,
    TableCustom,
    BondTableCustom,
    CommonSelect,
  },
  data() {
    return {
      moment,

      form: {
        benchmarkInterestRateValue: "",
        downPayment_money: "",
        purchasePrice_money: "",
        calcType: 1,
      },
      option: basicConfig(),
      basicList: [], //客户名称 列表,
      dataSouce: {},
      calculateForm: {},
      submitType: "submit",
      tableData: [],
      bondTableData: [],
      loading: false,
      timer: null,
      copyVisible: false,
      anticipatedValueDateType: false,
      leaseTermStandard: undefined,
      rentValueDateStandard: undefined,
    };
  },

  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    dataInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    planList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    beforeBjList: {
      type: Boolean,
      default: true,
    },
    id: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    ...mapGetters(["userInfo","permission"]),
    isShow() {
      return function () {
        return this.readOnly || this.dataInfo.isLocked == 1;
      };
    },
    dateRange() {
      const { graceFlag, calcType, interestRateModel, floatingMode } =
        this.form;
      return {
        graceFlag,
        calcType,
        interestRateModel,
        floatingMode,
      };
    },
  },
  watch: {
    readOnly: {
      handler: function (val) {},
      immediate: true,
    },
    dataInfo: {
      handler: function (val) {
        let data = JSON.parse(JSON.stringify(val));
        if (data.createDept && data.createDept > -1) {
          this.getDept(data.createDept);
        }
        this.setForm(data);
        this.option.column.filter((item) => {
          if (
            item.prop === "managerDeptName" ||
            item.prop === "managerUserName"
          ) {
            item.disabled = true;
          } else {
            item.disabled = this.readOnly || this.dataInfo.isLocked == 1;
          }

          if (
            item.prop === "custName" ||
            item.prop === "managerDeptName" ||
            item.prop === "managerUserName"
          ) {
            item.display = this.$route.query.beforeBjList ? true : false;
          }
        });
      },
      deep: true,
      immediate: true,
    },
    "form.quotationPrice": {
      handler(data) {
        this.form.purchasePrice_money = (
          (Number(data) * Number(this.form.purchasePrice)) /
          100
        ).toFixed(2);
        // this.form.downPayment_money = (
        //   (Number(data) * Number(this.form.downPayment)) /
        //   100
        // ).toFixed(2);
      },
    },
    "form.graceFlag": {
      handler(data) {
        if (data == 0) {
          this.form.gracePeriodDay = undefined;
          this.form.graceInterestRate = undefined;
        }
      },
    },

    dateRange: {
      handler(data) {
        this.$refs.form.option.column.filter((item) => {
          //  保理业务
          // if (
          //   item.prop === "overdueInterestRate" ||
          //   item.prop === "graceFlag" ||
          //   item.prop === "repaymentFrequencyBl"
          // ) {
          //   item.display = this.form.calcType == 1;
          // }

          // //  融资租赁
          // if (
          //   item.prop === "calculateRentMethod" ||
          //   item.prop === "interestTaxRate" ||
          //   item.prop === "repaymentFrequency" ||
          //   item.prop === "purchasePrice" ||
          //   item.prop === "purchasePrice1" ||
          //   item.prop === "paymentType"
          // ) {
          //   item.display = this.form.calcType == 2;
          // }
          if (
            item.prop === "gracePeriodDay" ||
            item.prop === "graceInterestRate"
          ) {
            item.display = this.form.graceFlag == 1 && this.form.calcType == 1;
          }

          // if (
          //   item.prop === "benchmarkInterestRateName" ||
          //   item.prop === "floatingMode" ||
          //   item.prop === "interestAdjustmentMode"
          // ) {
          //   item.display = this.form.interestRateModel == 1;
          // }
          // if (item.prop === "floatingRange") {
          //   item.display =
          //     this.form.floatingMode == 1 && this.form.interestRateModel == 1;
          // }
          // if (item.prop === "floatingPoint") {
          //   item.display =
          //     this.form.floatingMode == 2 && this.form.interestRateModel == 1;
          // }
        });
      },
    },
  },
  async mounted() {
    this.dictionaryMap();
    if (this.id && this.id > -1) {
      
    } else {
      this.basicInfo();
      let res = await this.setNewBjId();
      this.id = res;
      this.getDept(this.userInfo.dept_id);
    }
  },
  created() {},
  methods: {
    changeAnticipatedValueDate(val) {
      this.anticipatedValueDateType = true;
    },
    async setId(item) {
      this.anticipatedValueDateType = false;
      this.copyVisible = false;
      let form = item;
      let res = await this.detail(form.id);
      delete res.id;
      delete res.isLocked;
      res.outlays.map((item) => {
        delete item.otherOutlayId;
        delete item.rentalId;
      });
      let rentalName = await this.rentalName(res.name);
      res.name = rentalName;

      //还款日和还款期限发生变化
      this.leaseTermStandard = res.leaseTerm;
      (this.rentValueDateStandard = res.rentValueDate),
        this.$emit("calcSubmit", res);
      // this.setForm(res);
    },

    async rentalName(name) {
      return new Promise(async (resolve, reject) => {
        let res = await api.getRentalName({
          name,
        });
        if (res.data.code == 200) {
          resolve(res.data.data);
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
    async detail(id) {
      return new Promise(async (resolve, reject) => {
        let res = await getQuotaDetail({
          id: id,
        });
        if (res.data.code == 200) {
          resolve(res.data.data);
        } else {
          this.$message({
            type: "warning",
            message: res.data.msg,
          });
        }
      });
    },
    setForm(data) {
      if (Object.keys(data).length == 0) {
        return;
      }
      let outlays = data.outlays.map((item) => {
        return {
          ...item,

          outlayRate: Number(floatMul(item.outlayRate, 100)),
          // depositRate: (Number(item.depositRate) * 100).toFixed(2),
          outlayAmount: Number(item.outlayAmount),
        };
      });
      this.tableData = outlays.filter((item) => {
        return item.dictMainOutlayType == 1;
      });
      this.bondTableData = outlays.filter((item) => {
        return item.dictMainOutlayType == 2;
      });

      // if (data.downPayment && isNaN(data.downPayment)) {
      //   let downPayment = data.downPayment.split(",");
      //   data.downPayment = (Number(downPayment[0]) * 100).toFixed(2);
      //   data.downPayment_money = Number(downPayment[1]).toFixed(2);
      // }

      if (data.purchasePrice && isNaN(data.purchasePrice)) {
        let purchasePrice = data.purchasePrice.split(",");
        data.purchasePrice = (Number(purchasePrice[0]) * 100).toFixed(2);
        data.purchasePrice_money = Number(purchasePrice[1]).toFixed(2);
      }
      data.annualInterestRate = floatMul(Number(data.annualInterestRate) , 100);
      data.graceInterestRate = (Number(data.graceInterestRate) * 100).toFixed(
        2
      );

      data.overdueInterestRate = (
        Number(data.overdueInterestRate) * 100
      ).toFixed(2);
      data.floatingRange = (Number(data.floatingRange) * 100).toFixed(2);
      if (data.anticipatedValueDate) {
        data.anticipatedValueDate = this.dateConvert(data.anticipatedValueDate);
      }
      if (data.rentValueDate) {
        data.rentValueDate = this.dateConvert(data.rentValueDate);
      }
      data.quotationPrice = Number(data.quotationPrice).toFixed(2);

      this.form = data;

      //还款日和还款期限发生变化
      this.leaseTermStandard = data.leaseTerm;
      this.rentValueDateStandard = data.rentValueDate;

      this.basicInfo();
    },
    copy() {
      let self = this;
      if (this.form.isLocked == 1) {
        const confirmText = [
          "该方案已锁定，无法修改。是否确定复制方案？",
          "什么是锁定方案：已提交审批的方案",
        ];
        const newDatas = [];
        const h = this.$createElement;
        for (const i in confirmText) {
          newDatas.push(h("p", null, confirmText[i]));
        }
        this.$confirm("警告提示", {
          title: "提示",
          message: h("div", null, newDatas),
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            queryInventedId().then((res) => {
              if (res["data"]["code"] == 200) {
                self.id = res["data"]["data"];
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        queryInventedId().then((res) => {
          if (res["data"]["code"] == 200) {
            self.id = res["data"]["data"];
          }
        });
      }
    },
    dateConvert(val) {
      val = (val + "").replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
      return new Date(val);
    },

    changeInput(toName, name, type) {
      let form = this.form;
      if (this.form.quotationPrice) {
        if (type == "ratio") {
          form[toName] = (
            (Number(this.form.quotationPrice) * Number(this.form[name])) /
            100
          ).toFixed(2);
        } else {
          form[toName] = (
            (Number(this.form[name]) / Number(this.form.quotationPrice)) *
            100
          ).toFixed(2);
        }
        this.form = form;
      }
    },
    //基准利率
    setLpr(item) {
      this.$nextTick(() => {
        Object.assign(this.form, {
          ...this.form,
          benchmarkInterestRateName: item.name,
          benchmarkInterestRateId: item.id,
          benchmarkInterestRateValue: item.lprRate,
        });
      });
    },

    // 获取部门
    async getDept(id) {
      let ids= id?id.split(","):['']
      getDept(ids[0]).then((res) => {
        this.form.managerDeptName = res.data.data.deptName;
        // this.form.managerUserName = this.userInfo.user_name;
      });
    },
    async dictionaryMap() {
      let dataList = [
        {
          code: "calculate_rent_method",
          name: "",
        },
        {
          code: "interest_tax_rate",
          name: "",
        },
        {
          code: "repayment_frequency",
          name: "",
        },
        {
          code: "payment_type_rzzl",
          name: "",
        },
        {
          code: "interest_rate_model",
          name: "",
        },
        {
          code: "floating_mode",
          name: "",
        },
        {
          code: "interest_adjustment_mode",
          name: "",
        },
      ];
      let codeList = dataList.map((item) => {
        return item.code;
      });
      let res = await dictionaries(`code=${codeList.join(",")}`);
      if (res.data.code == 200) {
        this.dataSouce = res.data.data;
      }
    },
    // 保存   调用提交方法
    save(submitType) {
      let that = this;
      that.loading = true;
      clearTimeout(that.timer);
      that.timer = setTimeout(function () {
        that.$refs.form.validate((valid) => {
          if (valid) {
            that.$refs.form.submit();
          } else {
            that.$message.error("请将表单必填项填写完整");
          }
        });

        that.loading = false;
        that.submitType = submitType;
      }, 500);
    },
    // //测算   调用提交方法
    // calc(type) {
    //   let that = this;
    //   that.loading = true;
    //   clearTimeout(that.timer);
    //   that.timer = setTimeout(function () {
    //     // that.$refs.form.submit();
    //     that.submitType = type;
    //     that.formSubmit();
    //     that.loading = false;
    //   }, 500);
    // },
    // 防抖
    debounce(fn, delay) {
      var timer = null;
      return function () {
        clearTimeout(timer);
        var args = arguments;
        var that = this;
        timer = setTimeout(function () {
          fn.apply(that, args);
        }, delay);
      };
    },

    getData() {
      let self = this;
      let isTrue = false;
      let tableData = this.$refs.tableCustom.tableData;
      tableData.map((item) => {
        let judge = Object.values({
          outlayAmount: item.outlayAmount,
          outlayRate: item.outlayRate,
          // dictOutlayType: item.dictOutlayType,
          outlayWay: item.outlayWay,
        }).includes("");

        if (judge) {
          isTrue = true;
          return;
        }
        // return item.dictOutlayType;
      });
      if (isTrue) {
        this.$message.error("请将费用类型填写完整");
        return;
      }

      let bondTableCustom = this.$refs.bondTableCustom.tableData;

      bondTableCustom.map((item) => {
        let judge = Object.values({
          outlayAmount: item.outlayAmount,
          outlayRate: item.outlayRate,
          // dictDepositType: item.dictDepositType,
          outlayWay: item.outlayWay,
          expirationTreatment: item.expirationTreatment,
          // depositRate: item.depositRate,
        }).includes("");

        if (judge) {
          isTrue = true;
          return;
        }
        // return item.dictOutlayType;
      });
      if (isTrue) {
        this.$message.error("请将保证金类型填写完整");
        return;
      }
      let tableDataList = tableData.concat(bondTableCustom);
      let outlays = tableDataList.map((item) => {
        return {
          ...item,
          outlayRate: floatDiv(Number(item.outlayRate) , 100),
          // depositRate: Number(item.depositRate) / 100,
        };
      });

      if (
        (this.leaseTermStandard != this.form.leaseTerm ||
          (this.form.rentValueDate
            ? moment(this.rentValueDateStandard).format("YYYY-MM-DD")
            : undefined) !=
            (this.form.rentValueDate
              ? moment(this.form.rentValueDate).format("YYYY-MM-DD")
              : undefined)) &&
        this.leaseTermStandard &&
        this.rentValueDateStandard
      ) {
        this.form.planList = [];
        this.leaseTermStandard = this.form.leaseTerm;
        this.rentValueDateStandard = this.form.rentValueDate;
      }

      let data = {
        ...this.form,
        outlays,
        // downPayment: [
        //   Number(this.form.downPayment) / 100,
        //   this.form.downPayment_money,
        // ].join(","),
        // repaymentFrequency:1, //传  1  按月
        downPayment: [0, 0].join(","),
        purchasePrice: [0, 0].join(","),
        // purchasePrice: [
        //   Number(this.form.purchasePrice) / 100,
        //   this.form.purchasePrice_money,
        // ].join(","),
        annualInterestRate: this.form.annualInterestRate
          ? floatDiv(Number(this.form.annualInterestRate) , 100)
          : undefined,
        overdueInterestRate: this.form.overdueInterestRate
          ? floatDiv(Number(this.form.overdueInterestRate) , 100)
          : undefined,
        graceInterestRate: this.form.graceInterestRate
          ? floatDiv(Number(this.form.graceInterestRate) , 100)
          : undefined,
        floatingRange: this.form.floatingRange
          ? floatDiv(Number(this.form.floatingRange) , 100)
          : undefined,
        anticipatedValueDate: this.form.anticipatedValueDate
          ? moment(this.form.anticipatedValueDate)
              .format("YYYY-MM-DD")
              .replace(/[-]/g, "")
          : undefined,
        rentValueDate: this.form.rentValueDate
          ? moment(this.form.rentValueDate)
              .format("YYYY-MM-DD")
              .replace(/[-]/g, "")
          : undefined,
        conManageId: undefined,
        id: this.id && this.id > -1 ? this.id : undefined,
        rentalDayModified:
          this.submitType == "calc" && this.anticipatedValueDateType
            ? true
            : false,
      };
      return data;
    },
    formSubmit(done, loading) {
      let self = this;

      let data = this.getData();
      if (data == undefined) {
        return;
      }
      let apiName = "submitQuota";
      if (self.submitType == "calc") {
        apiName = "calcQuota";
        // data.planList = self.planList;
      }
      api[apiName](data).then(
        (res) => {
          self.$message({
            type: "success",
            message: "操作成功!",
          });
          if (self.submitType == "calc") {
            self.anticipatedValueDateType = false;
            self.$emit("calcSubmit", res.data.data);
          } else {
            // 如果是列表进来返回上一页
            if (self.$route.query.beforeBjList) {
              self.$router.go(-1);
            }
            // 如果组件导入进来 返回id
            else {
              self.$emit("calcSubmit", data, "emit");
            }
          }

          done();
        },
        (error) => {
          done();
          loading();
          window.console.log(error);
        }
      );
    },
    //提交
    handleSubmit(form, done, loading) {
      let self = this;
      this.loading = false;
      self.formSubmit(done, loading);
    },
    calcSubmit() {},

    //客户名称列表
    basicInfo() {
      if (this.basicList.length > 0) {
        this.basicInfoCustName();
      } else {
        basicInformations({}).then((res) => {
          this.basicList = res.data.data;
          this.basicInfoCustName();
        });
      }
    },
    //客户名称列表  匹配
    basicInfoCustName() {
      this.basicList.map((item) => {
        if (item.id == this.form.custId) {
          this.form.custName = item.custName;
        }
      });
    },
    //选择了客户名称 的各种数据回填
    changeCustName(data) {
      this.form.custName = data.custName;
      this.form.custId = data.id;
    },
  },
};
</script>
<style scoped lang="scss">
.flex_wrapper {
  display: flex;
  align-items: center;
}

.select-item {
  padding: 0 20px !important;
}

/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 4px;
}
</style>
